import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import InputField from "src/components/common/input-field";

function SocialMediaAccs() {
  const { t } = useTranslation();
  return (
    <div
      id="SocialMediaAccs"
      className="font-ar max-w-[717px] w-[calc(60vw)] flex mobile:ml-0 bg-white mobile:h-[412px] mobile:px-4 rounded-lg mobile:shadow-none mobile:w-[calc(100vw-32px)] mobile:mr-0 items-center content-center justify-center drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]"
    >
      <div className="w-[425px] h-[425px] mt-8 mobile:w-[361px] mobile:h-[412px] mobile:px-4">
        <p className="mb-4 mobile:text-mint-500 mobile:text-xl mobile:font-medium mobile:px-2 ">
          {t("socialMediaAccs.container.socicalMediaAccounts")}
        </p>

        <div className="flex flex-col gap-6 w-[425px] h-[111px] mobile:w-[345px] mobile:h-[87px]">
          <p className="text-zinc-700">
            {t("socialMediaAccs.container.instagram")}
          </p>
          <div className="flex flex-row gap-3">
            <button type="button" disabled={true} className="text-zinc-400">
              <AiOutlineClose className="" />
            </button>
            <div className="">
              <label className="mr-2 text-zinc-500 font-medium w-[53px] h-[27px] ">
                @a.aas
              </label>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-6 w-[425px] h-[111px] mobile:w-[345px] mobile:h-[87px] mobile:px-1">
          <p className="text-zinc-700">
            {t("socialMediaAccs.container.whatsapp")}
          </p>
          <div className="flex flex-row gap-3">
            <button type="button" disabled={true} className="text-zinc-400">
              <AiOutlineClose className="" />
            </button>
            <div className="">
              <label className="mr-2 text-zinc-500 font-medium w-[53px] h-[27px] ">
                http//:fdgdkjfvbskjfchaosifhcaoicjajc
              </label>
            </div>
          </div>
        </div>
        <InputField
          title={`${t("socialMediaAccs.container.x")}`}
          placeHolder={""}
          px="mobile:px-4"
          width="w-[214px] mobile:w-[214px]"
          hight="h-[61px] mobile:h-[61px]"
        />
        <button className="text-mint-500 mt-4 mobile:px-4">
          {t("app.shared.save")}
        </button>
      </div>
    </div>
  );
}

export default SocialMediaAccs;
